import React, { PureComponent } from 'react';
import { lightenDarkenColor } from 'utils/colors';
import styles from './Pulse.module.scss';

interface Props {
  width: number | undefined;
  height: number | undefined;
  color?: string;
}

export class Pulse extends PureComponent<Props> {
  static defaultProps = {
    width: undefined,
    height: undefined,
    // color,
  };
  render() {
    const { width, height, color } = this.props;
    const dotColor = color && lightenDarkenColor(color, 40);
    const pulseColor = color && lightenDarkenColor(color, -20);

    return (
      <div className={styles.container} style={{ height, width }}>
        <div className={styles.circle} style={{ color: dotColor }} />
        <div className={styles.pulseWave} style={{ color: pulseColor }} />
      </div>
    );
  }
}
